<mat-toolbar class="topBar">
    <div style="display:flex; align-items:center; gap:10px">
  
      <!-- Back to Sets -->
      <button mat-mini-fab
              class="example-icon"
              type="button"
              aria-label="Example icon-button with menu icon"
              [matTooltip]="matToolTipText"
              matTooltipPosition="below"
              (click)="navigateBack()">
        <mat-icon>
          arrow_back
        </mat-icon>
      </button>
  
      <!-- Back to Home -->
      <button mat-mini-fab
              class="example-icon"
              type="button"
              matTooltip="Back to Home"
              matTooltipPosition="below"
              (click)="router.navigate(['menu'], { queryParams: { fishery: 1 } })">
        <mat-icon>
          home
        </mat-icon>
      </button>
  
      <span *ngIf="viewMode == 0">HMS Current Delivery</span>
      <span *ngIf="viewMode == 1">Logbook</span>
      <span *ngIf="viewMode == 2">Editing Logbook</span>  
      <span *ngIf="viewMode == 3">Draft Logbook</span>
    </div>   
  
    <span class="spacer"></span>
  
    <mat-spinner *ngIf="dataSync.sync_in_progress()" [diameter]="35" class="mat-spinner-color"></mat-spinner>
    <!-- Enable edits -->
    <button mat-stroked-button
            *ngIf="viewMode != 0"
            class="edit-button"
            type="button"
            [hidden]="!canEdit"
            matTooltipPosition="below"
            (click)="viewMode == 1 ? enableEdits() : discardEdits(true)">
      <span *ngIf="viewMode == 1">
        Edit
      </span>
      <span *ngIf="viewMode == 2">
        Cancel
      </span>
    </button>
  
  </mat-toolbar>
  
<div class="container" style="padding-top: 15px; max-width: none;">

  <form [formGroup]="landingForm">

    <div class="row">
      <mat-form-field>
        <mat-label>Vessel</mat-label>
        <mat-select formControlName="vessel" [compareWith]="compareVessel" required>
          <mat-option *ngFor="let v of vesselOptions()" [value]="v">{{v}}</mat-option>
          <mat-option (click)="addVessel()">
            Add New
          </mat-option>
        </mat-select>
        <mat-error *ngIf="landingForm.invalid">Required</mat-error>
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field>
        <mat-label>Vessel Operator</mat-label>
        <input matInput formControlName="operator" required>
        <mat-error *ngIf="landingForm.invalid">Required</mat-error>
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field>
        <mat-label>
          Departure Date
        </mat-label>
        <input matInput readonly formControlName="departureDate" (click)="editDateTime('departureDate')" required>
        <mat-error *ngIf="landingForm.invalid">Required</mat-error>
      </mat-form-field>
    </div>


    <!-- This will be an auto-complete -->
    <div class="row">
      <mat-form-field>
        <mat-label>Departure Port</mat-label>
        <input matInput formControlName="departurePort" [matAutocomplete]="dept" required>
        <mat-autocomplete #dept="matAutocomplete">
          <mat-option *ngFor="let option of filteredDeparturePorts | async" [value]="option">
            {{option}}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="landingForm.invalid">Select an item</mat-error>
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field>
        <mat-label>
          Return Date
        </mat-label>
        <input matInput readonly formControlName="arrivalDate" (click)="editDateTime('arrivalDate')" required>
        <mat-error *ngIf="landingForm.invalid">Required</mat-error>
      </mat-form-field>
    </div>


    <!-- This will be an auto-complete -->
    <div class="row">
      <mat-form-field>
        <mat-label>Return Port</mat-label>
        <input matInput formControlName="arrivalPort" [matAutocomplete]="arrival" required>
        <mat-autocomplete #arrival="matAutocomplete">
          <mat-option *ngFor="let option of filteredArrivalPorts | async" [value]="option">
            {{option}}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="landingForm.invalid">Select an item</mat-error>
      </mat-form-field>
    </div>

  </form>

  <div class="row">
    <mat-toolbar style="background-color: var(--elog-brand); color: var(--elog-brand-on); border-bottom: 3px solid var(--elog-accent-strong);">
      <span>Unloadings</span>
      <span class="spacer"></span>

      <!-- Add Unloading -->
      <button mat-mini-fab
              *ngIf="viewMode != 1"
              class="blue-icon-button"
              type="button"
              matTooltip="Add Unloading"
              matTooltipPosition="below"
              (click)="openUnloadingDialog(landing.unloading.length)">
        <mat-icon>
          add
        </mat-icon>
      </button>
    </mat-toolbar>
  </div>

  <!-- Unloadings Table  -->
  <div class="row">
    <table mat-table [dataSource]="landing.unloading" class="mat-elevation-z8">

      <ng-container matColumnDef="unloadingPort">
        <tr>
          <th mat-header-cell *matHeaderCellDef> Unloading Port </th>
          <td mat-cell *matCellDef="let unl"> {{unl.unloadingPort.name}} </td>
        </tr>
      </ng-container>

      <ng-container matColumnDef="unloadingDate">
        <tr>
          <th mat-header-cell *matHeaderCellDef> Unloading Date </th>
          <td mat-cell *matCellDef="let unl"> {{unl.unloadingDate | date:'MM-dd-yy'}} </td>
        </tr>
      </ng-container>

      <ng-container matColumnDef="species">
        <tr>
          <th mat-header-cell *matHeaderCellDef> Species </th>
          <td mat-cell *matCellDef="let unl">
            <ng-container *ngFor="let species of unl.species">
              <div>{{ species.speciesName }}</div>
            </ng-container>
          </td>
        </tr>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="unloadingsColumns"></tr>
      <tr mat-row (click)="openUnloadingDialog(index)" *matRowDef="let row; columns: unloadingsColumns; let index=index;"></tr>

    </table>
  </div>

  <div class="row">
    <mat-toolbar style="background-color: var(--elog-brand); color: var(--elog-brand-on); border-bottom: 3px solid var(--elog-accent-strong);">
      <span>Daily Fishing Logs Included</span>
      <span class="spacer"></span>

          <!-- Add Set to Delivery -->
          <button mat-mini-fab
            *ngIf="viewMode != 1"
             class="blue-icon-button"                  
             type="button"                 
             aria-label="Example icon-button with share icon"              
             matTooltip="Add Set to Delivery"             
             matTooltipPosition="below"              
             (click)="openSetSelection()">
            <mat-icon>
              add
            </mat-icon>
          </button>
    </mat-toolbar>

  </div>

  <div class="row">
    <div *ngFor="let set of sortedSets; let index=index;" style="padding-left: 0px; padding-right: 0px; font-size: 16px;">
      <mat-card matRipple (click)="goToSet(set.fishingEventID)" style="padding:16px;">
        <div class="row">
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <span><b>Fishing Date: </b>{{set.startDate | date:'EEEE, MMM d, y'}}</span>
            <mat-icon *ngIf="viewMode == 1 || validSets.get(set.fishingEventID)">done</mat-icon>
            <mat-icon *ngIf="viewMode != 1 && !validSets.get(set.fishingEventID)">error</mat-icon>
          </div>
        </div>     
        <mat-card-actions *ngIf="(viewMode != 1 && !preExistingSets.get(set.fishingEventID)) && (viewMode != 3)">
          <button mat-fab
                  class="text-button"
                  type="button"
                  (click)="removeSet(index)">
            Remove
          </button>
        </mat-card-actions>
        <mat-card-footer></mat-card-footer>
      </mat-card>
      <br>
    </div>
  </div>
  <br>
  <br>
  <br>
  <br>
  <br>
</div>
    

  <!-- Bottom bar -->
<mat-toolbar class="toolbarNav">
  <div class="example-button-container">

    <!-- Delivery Summary -->
    <button mat-fab
            class="bottom-toolbar-button"
            type="button"
            aria-label="Example icon button with a plus one icon"
            matTooltip="Summary"
            matTooltipPosition="above"
            (click)="router.navigate(['summary_report', 'HMS', viewMode == 0 ? -1 : this.completedInd], { queryParams: { previous: previousScreen, draft: viewMode == 3 } })">
      <mat-icon>
        description
      </mat-icon>
    </button>
  </div>

  <!-- Delivery Errors -->
  <div *ngIf="errors.length > 0 && viewMode != 1" class="example-button-container">
    <button mat-fab
            class="bottom-toolbar-button"
            type="button"
            aria-label="Example icon button with a plus one icon"
            matTooltip="Errors/Warnings"
            matTooltipPosition="above"
            (click)="openErrorDialog()">
      <mat-icon *ngIf="onlyWarnings">
        warning
      </mat-icon>
      <mat-icon *ngIf="!onlyWarnings">
        report
      </mat-icon>
    </button>
  </div>

  <!-- Submit Delivery -->
  <div *ngIf="viewMode != 1" class="example-button-container">
    <button mat-fab
            class="bottom-toolbar-button"
            type="button"
            aria-label="Example icon button with a plus one icon"
            matTooltip="Submit Delivery"
            matTooltipPosition="above"
            (click)="openSubmitDialog()">
      <mat-icon>
        drive_folder_upload
      </mat-icon>
    </button>
  </div>
</mat-toolbar>
